/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Lead_OverlineInputs */

const en_cp_lead_overline = /** @type {(inputs: Cp_Lead_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CAMPUS LEAD`)
};

const id_cp_lead_overline = /** @type {(inputs: Cp_Lead_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CAMPUS LEAD`)
};

/**
* | output |
* | --- |
* | "CAMPUS LEAD" |
*
* @param {Cp_Lead_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_lead_overline = /** @type {((inputs?: Cp_Lead_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Lead_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_lead_overline(inputs)
	return en_cp_lead_overline(inputs)
});